import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { PropertyLevelOffersCard } from '@shared-ui/lodging-property-offers';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const PropertyLevelOffersCardWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <ErrorBoundary label="PropertyLevelOffersCard">
    <PropertyLevelOffersCard inputs={inputs} showBorder={false} skipSsr />
  </ErrorBoundary>
);

PropertyLevelOffersCardWrapper.displayName = 'PropertyLevelOffersCardWrapper';
export const SharedUiPropertyLevelOffersCardWrapper = withSharedUiPropertyOffers(PropertyLevelOffersCardWrapper);
